export default __webpack_public_path__ + "static/media/distDetail.be02a207.svg";